import { css } from '@emotion/react'

import { MapaSidebarPanel } from '../components/MapaSidebarPanel'
import { MAPA_SIDEBAR_NAV_ITEMS, MapaSidebarNavItemEnum } from '../model-territorioMapa'
import { TerritorioMapaBuscaForm } from './components/TerritorioMapaBuscaForm'
import { TerritorioMapaBuscaFormModel } from './model-territorioMapaBusca'

interface MapaBuscaPanelProps {
  defaultValues: TerritorioMapaBuscaFormModel
  initialValues: TerritorioMapaBuscaFormModel
  onSubmit: (values: TerritorioMapaBuscaFormModel) => void
}

export function MapaBuscaPanel(props: Readonly<MapaBuscaPanelProps>) {
  const { defaultValues, initialValues, onSubmit } = props

  return (
    <MapaSidebarPanel title={MAPA_SIDEBAR_NAV_ITEMS[MapaSidebarNavItemEnum.BUSCA].label}>
      <div css={styles.container}>
        <TerritorioMapaBuscaForm defaultValues={defaultValues} initialValues={initialValues} onSubmit={onSubmit} />
      </div>
    </MapaSidebarPanel>
  )
}

const styles = {
  container: css`
    padding-top: 0.5rem;
  `,
}
